let instance = null;

const handleIntersect = (entries) => {
  // The callback will return an array of entries, even if you are only observing a single item
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.timeline.play();
    } else {
      // entry.target.timeline.seek('hidden').pause();
    }
  });
};

export default class BBIntersectionObserver {
  constructor(root = null, rootMargin = '0px', threshold = 0.3) {
    this.options = { root, rootMargin, threshold };

    if (!instance) {
      instance = this.initObserver();
    }
    return instance;
  }

  initObserver() {
    return new IntersectionObserver((entries) => {
      handleIntersect(entries);
    }, this.options);

    // const targets = document.querySelectorAll('.blocks__block');
    // const stage = document.querySelector('.teaser-highlight--is-stage  ');
    // // Finally start observing the target element
    // this.observer.observe(stage);
    // targets.forEach((target) => this.observer.observe(target));
  }
}
